import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const defaultString = '-'

class YenSpan extends React.PureComponent {
  static defaultProps = {
    showIcon: true,
    fixed: 2,
    color: false,
    smallSymbol: false,
    children: defaultString
  }
  static propTypes = {
    showIcon: PropTypes.bool,
    fixed: PropTypes.number,
    smallSymbol: PropTypes.bool,
    color: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  render () {
    const {
      showIcon,
      children,
      color,
      smallSymbol,
      className,
      ...props
    } = this.props
    const classNames = classnames('yen-span', className, {
      'yen-span--color': color,
      'yen-span--small-symbol': smallSymbol
    })
    return <span className={classNames} {...props}>
      {
        showIcon
          // ? <FontAwesomeIcon icon={'yen-sign'} />
          ? <span className={'yen-span__symbol'}>&#165;</span>
          : null
      }
      &nbsp;
      <span className={'yen-span__text'}>{this.handleValue(children)}</span>
    </span>
  }

  handleValue = value => {
    let v = Number(value)
    if (value === defaultString || Number.isNaN(v)) {
      // console.warn(`YenSpan receipt a error number: ${value}`)
      return defaultString
    }
    return v.toFixed(this.props.fixed)
  }
}

export { YenSpan }
